export default __webpack_public_path__ + "static/media/gallery_01.e361b8d4.jpg";